import {apiClient} from 'core/apiClient';
import {ChecksGridRawRow, ReceiptDetailRaw, ProductContentRawRow} from 'types';
import {
    ApiSortings,
    ApiFilters,
    ApiPaging,
    SimplePaginationContent,
    SimplePaginationContentRaw,
} from 'types/api';

const CHECKS_URL = '/service/receipts';

let gridTokensCache: Record<number, string | null> = {
    0: null,
};

export function clearDocumentsGridCache(): void {
    gridTokensCache = {
        0: null,
    };
}

export async function fetchChecksGrid(params: {
    sortings: ApiSortings;
    filters: ApiFilters;
    paging: ApiPaging;
}): Promise<SimplePaginationContent<ChecksGridRawRow>> {
    const {pageSize, pageNumber} = params.paging;
    const token = gridTokensCache[pageNumber];
    if (token === undefined) {
        throw new Error('Cache error');
    }
    const mappedPaging = pageNumber === 0 ? {pageSize} : {pageRef: token};
    const responseData: SimplePaginationContentRaw<ChecksGridRawRow> = await apiClient
        .post(CHECKS_URL, {...params, paging: mappedPaging})
        .then((res) => res.data);

    if (responseData.nextPageRef) {
        gridTokensCache[pageNumber + 1] = responseData.nextPageRef;
    }

    return {
        content: responseData.data,
        hasNext: !!responseData.nextPageRef,
    };
}

export async function fetchReceiptsDetail(id: string): Promise<ReceiptDetailRaw> {
    // const result: any = await fakeApi.receiptsDetail(id);
    // return result;
    return (
        await apiClient.post(`${CHECKS_URL}/details`, {
            receiptId: id,
        })
    ).data;
}

export async function fetchReceiptProductsGrid(params: {
    receiptId: string;
    paging: ApiPaging;
    sortings: ApiSortings;
    filters: ApiFilters;
}): Promise<ProductContentRawRow[]> {
    return (await apiClient.post(`${CHECKS_URL}/details/products`, params))
        .data as ProductContentRawRow[];
}
